import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccessibilityService {
  constructor() {}
  talk(text: string) {
    var el = document.createElement('div');
    var id = 'speak-' + Date.now();
    el.setAttribute('id', id);
    el.setAttribute('aria-live', 'assertive');
    el.classList.add('screen-reader-only');
    document.body.appendChild(el);

    window.setTimeout(function () {
      document.getElementById(id).innerHTML = text;
    }, 100);

    window.setTimeout(function () {
      document.body.removeChild(document.getElementById(id));
    }, 1000);
  }
}
